import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './styles.module.scss'
import Button from 'srcReact/components/common2/Button'
import { useTranslation } from 'react-i18next'
import Avatar from 'srcReact/components/common2/Avatar'
import useInfinitScroll from 'srcReact/helpers/hooks/useInfinitScroll'
import { workplaceSettingsActions } from 'srcReact/WorkplaceSettingsPage'
import Spinner from 'srcReact/components/common2/Spinner'

const MemberManagePopin = ({ workplaceId, workplaceName, closeModal }) => {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const {
    login: { user: loggedInUser },
    workplaceSettings: { workplace_members }
  } = useSelector((state) => state)
  const [withMemberInterests] = useState(0)
  const [orderby] = useState('firstname')
  const [scope] = useState('participant')
  const [searchText] = useState('')
  const [withPhoto] = useState(1)
  const [photoSize] = useState(80)
  const [selectedUserIds, setSelectedUserIds] = useState([])
  const [pagination, setPagination] = useState({
    nextOffset: 0,
    isPagination: false
  })

  useEffect(() => {
    if (workplaceId > 0) {
      dispatch(
        workplaceSettingsActions.getWorkplaceMembers(
          workplaceId,
          scope,
          searchText,
          orderby,
          withMemberInterests,
          withPhoto,
          photoSize
        )
      )
    }
  }, [workplaceId])
  useEffect(() => {
    if (workplaceId > 0 && pagination.isPagination) {
      dispatch(
        workplaceSettingsActions.getWorkplaceMembersPagination(
          workplaceId,
          scope,
          searchText,
          orderby,
          withMemberInterests,
          withPhoto,
          photoSize,
          pagination.nextOffset
        )
      )
    }
  }, [pagination])

  const handleManageMember = () => {
    if (selectedUserIds?.length > 0) {
      const userIds = selectedUserIds?.toString()
      dispatch(workplaceSettingsActions.addWorkplaceMemberRole(workplaceId, userIds, 'workplace-manager', 'add'))
    }
    closeModal()
  }
  const onSelectUser = (member) => {
    selectedUserIds.push(member.user_id)
    setSelectedUserIds(selectedUserIds)
  }
  const onUnselectUser = (member) => {
    const updatedSelectedUserIds = selectedUserIds.filter((id) => id !== member.user_id)
    setSelectedUserIds(updatedSelectedUserIds)
  }
  const lastMemberRef = useInfinitScroll(
    workplace_members?.loading,
    workplace_members?.members_stats?.remaining,
    workplace_members?.members_stats?.next_offset,
    setPagination,
    [workplace_members?.loading]
  )

  return (
    <div className={styles.manageMembersModalContainer}>
      {workplace_members?.loaded && workplace_members?.members?.length > 0 && (
        <React.Fragment>
          <h2
            className={styles.title}
            dangerouslySetInnerHTML={{
              __html: t('workplaceSettings.popin.addNewManager.titleSearch', {
                workplace: workplaceName
              })
            }}
          />
          <p className={styles.info}>{t('workplaceSettings.popin.addNewManager.infoSearch')}</p>
        </React.Fragment>
      )}

      <div
        className={`${styles.manageMembers} ${
          workplace_members?.loaded && workplace_members?.members?.length > 3 ? styles.grid : styles.flex
        }`}>
        {!workplace_members?.loading && workplace_members?.loaded && workplace_members?.members?.length === 0 ? (
          <p className={styles.inviteNew}>{t('workplaceSettings.popin.addNewManager.allWorkplaceManager')}</p>
        ) : (
          workplace_members?.loaded &&
          workplace_members?.members?.length > 0 &&
          workplace_members?.members?.map((member, index) => {
            const isLastMember = workplace_members?.members?.length === index + 1
            return (
              <Avatar
                userId={member.user_id}
                firstname={member.firstname}
                lastname={member.lastname}
                commonInterestsCount={member.shared_interest_count}
                profilePicture={member.profile_picture_url}
                lastMemberRef={isLastMember ? lastMemberRef : null}
                key={'member_' + member.user_id}
                rounded
                showUserName
                selectMode={true}
                selectIcon='check'
                mimeType={member.mime_type}
                originalTag={member.original_tag}
                isOriginal={member.is_original}
                imgWrapperSize='large84'
                user={member}
                selectAction={onSelectUser}
                unselectAction={onUnselectUser}
                withExpertiseGroup={member.with_expertise_group}
              />
            )
          })
        )}
      </div>

      {workplace_members?.loaded && (
        <Button
          text={
            workplace_members?.members?.length > 0
              ? t('workplaceSettings.popin.addNewManager.makeWorkplaceManager')
              : t('workplaceSettings.popin.addNewManager.allWorkplaceManagerButton')
          }
          handleClick={handleManageMember}
          customStyle={styles.addNewManagerBtn}
          size='large'
        />
      )}

      {workplace_members?.loading && !workplace_members?.loaded && <Spinner />}
    </div>
  )
}

export default MemberManagePopin
